import { Box, FormControlLabel, Radio, RadioGroup, Typography } from '@material-ui/core'

import { getSegmentValue, getUpdatedSegment } from 'components/SegmentSelector/segment-service'

import { withContext } from '../Context'

export const IS_PRIVATE_SEGMENT = 'IsPrivate'
export const HAS_REDUCED_LUNCH_SEGMENT = 'HasReducedLunch'

enum HighSchoolType {
  All = 'All',
  Private = 'Private',
  Public = 'Public',
}

type HighSchoolTypeSelectorProps = {
  criteria: string
  segment: object
  onChange: (criteria: string, segmentName: string, value: any, operation: string) => void
  updateSegment: (segment: object) => void
}

export const HighSchoolTypeSelector = ({
  criteria = 'Must',
  segment,
  onChange,
  updateSegment,
}: HighSchoolTypeSelectorProps) => {
  const isPrivateSegmentValue = getSegmentValue(segment, criteria, IS_PRIVATE_SEGMENT)
  const hasReducedLunchSegmentValue = getSegmentValue(segment, criteria, HAS_REDUCED_LUNCH_SEGMENT)
  const includesTitle1 = hasReducedLunchSegmentValue.includes(true)

  const isPrivate = isPrivateSegmentValue.includes(true)
  const isPublic = isPrivateSegmentValue.includes(false)
  const isAll = isPrivateSegmentValue.length === 0

  return (
    <>
      <Box
        pt={3}
        pb={2}
      >
        <Typography
          variant="subtitle2"
          color="textPrimary"
          className="title"
        >
          Type
        </Typography>
      </Box>
      <Box
        display="flex"
        alignItems="center"
        pl={1}
      >
        <RadioGroup
          onChange={(e) => {
            const selectedType = e.target.value
            if (selectedType === HighSchoolType.All) {
              let updatedSegment = getUpdatedSegment(segment, criteria, IS_PRIVATE_SEGMENT, [])
              updatedSegment = getUpdatedSegment(updatedSegment, criteria, HAS_REDUCED_LUNCH_SEGMENT, [])
              updateSegment(updatedSegment)
            } else if (selectedType === HighSchoolType.Private) {
              let updatedSegment = getUpdatedSegment(segment, criteria, IS_PRIVATE_SEGMENT, [true])
              updatedSegment = getUpdatedSegment(updatedSegment, criteria, HAS_REDUCED_LUNCH_SEGMENT, [])
              updateSegment(updatedSegment)
            } else if (selectedType === HighSchoolType.Public) {
              let updatedSegment = getUpdatedSegment(segment, criteria, IS_PRIVATE_SEGMENT, [false])
              updatedSegment = getUpdatedSegment(
                updatedSegment,
                criteria,
                HAS_REDUCED_LUNCH_SEGMENT,
                includesTitle1 ? [true] : [],
              )
              updateSegment(updatedSegment)
            }
          }}
          aria-label="High School Type"
        >
          <FormControlLabel
            value={HighSchoolType.All}
            label={HighSchoolType.All}
            control={
              <Radio
                checked={isAll}
                color="primary"
              />
            }
          />
          <FormControlLabel
            value={HighSchoolType.Private}
            label={HighSchoolType.Private}
            control={
              <Radio
                checked={isPrivate}
                color="primary"
              />
            }
          />
          <FormControlLabel
            value={HighSchoolType.Public}
            label={HighSchoolType.Public}
            control={
              <Radio
                checked={isPublic}
                color="primary"
              />
            }
          />
        </RadioGroup>
      </Box>
      <Box
        display="flex"
        alignItems="center"
        pl={5}
        pb={1}
      >
        {isPublic && (
          <RadioGroup
            onChange={(e) => {
              const isTitle1 = e.target.value === 'true'
              onChange(criteria, HAS_REDUCED_LUNCH_SEGMENT, isTitle1 ? [true] : [], 'in')
            }}
            aria-label="Public School Type"
          >
            <FormControlLabel
              label={HighSchoolType.All}
              value={false}
              control={
                <Radio
                  checked={!includesTitle1}
                  color="primary"
                />
              }
              disabled={!isPublic}
            />
            <FormControlLabel
              value={true}
              control={
                <Radio
                  checked={includesTitle1}
                  color="primary"
                />
              }
              label={
                <>
                  <Typography variant="body1">Title I Eligible</Typography>
                  <Typography
                    variant="body2"
                    color="textSecondary"
                  >
                    Schools where at least 40% of students receive free and reduced lunch.
                  </Typography>
                </>
              }
              disabled={!isPublic}
            />
          </RadioGroup>
        )}
      </Box>
    </>
  )
}

export default withContext(HighSchoolTypeSelector)
